<!-- eslint-disable max-len -->
<template>
  <v-main>
    <v-container fluid class="mt-16">
      <v-card
          :flat="$vuetify.theme.dark"
          :outlined="$vuetify.theme.dark"
          class="mx-auto"
          rounded="lg"
          max-width="900px"
      >
        <v-dialog
          v-model="forgotPasswordDialog"
          max-width="300"
        >
          <v-card light>
            <v-card-title class="text-h5">
              Request status
            </v-card-title>
            <v-card-text>{{ forgotPasswordResponse }}</v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="forgotPasswordDialog = false"
              >Ok</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-row no-gutters>
          <v-col cols="6" class="d-none d-sm-block">
            <div style="display: flex; width: 100%; height: 100%;">
              <img
                src="@/assets/mark_bgs/Landrum-HR-Interior-7.png"
                style="border-radius: 8px 0 0 8px; min-width: 100%;"
                alt=""
              >
            </div>
          </v-col>
          <v-col cols="12" sm="6">
            <v-form
              ref="form"
              @submit="submit"
              onSubmit="return false;"
            >
              <v-row class="text-center">
                <v-col cols="12">
                  <v-img
                    :src="chooseLogo2"
                    max-width="80%"
                    class="mx-auto mt-16"
                  ></v-img>
                </v-col>
                <v-col cols="12">
                  <div
                    style="font-family: Fira+Sans !important;"
                    class="text-h5"
                    >Forgot Password</div>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="email"
                    :rules="[rules.required, rules.email]"
                    @keyup.enter="requestPasswordReset"
                    label="Email"
                    class="mx-8"
                    validate-on-blur
                    @blur="() => $refs.form.resetValidation()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <div class="mx-8">
                    <v-btn
                      large
                      outlined
                      class="my-5 text-capitalize"
                      block
                      @click="requestPasswordReset"
                      :loading="btnLoading"
                    >Send reset request</v-btn>
                  </div>
                </v-col>
                <v-col cols="6" offset="6" class="mb-3">
                  <a href="/" class="mx-8">Return to login</a>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <div class="d-flex justify-center pa-2">
      <v-switch
        v-model="toggleTheme"
        inset
      >
        <template v-slot:label>
          <v-icon>mdi-theme-light-dark</v-icon>
        </template>
      </v-switch>
    </div>
  </v-main>
</template>

<script>
export default {
  name: 'ForgotPassword',
  data: () => ({
    session: null,
    email: '',
    btnLoading: false,
    rules: {
      required: (value) => !!value || 'Required',
      // eslint-disable-next-line max-len
      email: (value) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || 'Email is invalid',
    },
  }),
  computed: {
    toggleTheme: {
      get() {
        return this.$vuetify.theme.dark;
      },
      set(value) {
        this.$vuetify.theme.dark = value;
        localStorage.setItem('darkMode', value);
      },
    },
    chooseLogo() {
      if (this.$vuetify.theme.dark) {
        return 'https://assets.landrumhr.com/logos/Solutions-Color.png';
      }

      return 'https://assets.landrumhr.com/logos/Solutions-Color.png';
    },
    chooseLogo2() {
      if (this.$vuetify.theme.dark) {
        return 'https://assets.landrumhr.com/logos/Solutions-Color.png';
      }

      return 'https://assets.landrumhr.com/logos/Solutions-Color.png';
    },
    forgotPasswordDialog: {
      get() {
        return this.$store.state.forgotPasswordDialog;
      },
      set(value) {
        this.$store.commit('updateForgotPasswordDialog', value);
      },
    },
    forgotPasswordResponse: {
      get() {
        return this.$store.state.forgotPasswordResponse;
      },
      set(value) {
        this.$store.commit('updateForgotPasswordResponse', value);
      },
    },
    prospectLoginErrorDialog: {
      get() {
        return this.$store.state.prospectLoginErrorDialog;
      },
      set(value) {
        this.$store.commit('updateProspectLoginErrorDialog', value);
      },
    },
  },
  methods: {
    requestPasswordReset() {
      if (this.$refs.form.validate()) {
        this.btnLoading = true;
        this.$store.dispatch('forgotPassword', this.email).then(() => {
          this.btnLoading = false;
          this.$matomo.trackEvent('Authentication', 'Prospect', 'Requesting forgot password');
        });
      }
    },
  },
};
</script>

<style lang="scss">

</style>
